export enum MainGraphTypes {
  SIMCARDS_ONLINE = 'Dispositivos Online',
  TRANSACTIONS_PAY = 'transações',
}

export enum SimcardsOnlineGraphTypes {
  PRODUCT_GRAPH = 'by-product',
  TECHNOLOGY_GRAPH = 'by-technology',
  OPERATOR_GRAPH = 'by-operator',
  MACROREGIAO_GRAPH = 'by-macroregion',
  STATE_GRAPH = 'by-state',
}

export enum TransactionsPayGraphTypes {
  AVERAGE_TIME = 'average-time',
  TRANSACTIONS_BY_STATUS = 'transactions-by-status',
  TRANSACTION_HISTORY = 'transaction-history',
  TRANSACTION_STATUS = 'transaction-status',
  TRANSACTIONS_BY_TYPE = 'transactions-by-type',
}

export enum AlarmChannelOptions {
  TELEGRAM = 'telegram',
  EMAIL = 'email',
}

export enum AlarmTriggerOptions {
  THRESHOLD = 'threshold',
  PERCENTUAL_VARIATION = 'variacao_percentual',
  SEASONAL = 'sazonal',
}

export enum AlarmMomentWeekOptions {
  SUNDAY = '0s',
  MONDAY = '1s',
  TUESDAY = '2s',
  WEDNESDAY = '3s',
  THURSDAY = '4s',
  FRIDAY = '5s',
  SATURDAY = '6s',
}

export enum alarmGraphSimcardOptions {
  SIMCARD_PRODUCT = 'simcard_produto',
  SIMCARD_TECHNOLOGY = 'simcard_tecnologia',
  SIMCARD_OPERATOR = 'simcard_operadora',
  SIMCARD_STATE = 'simcard_estado',
  SIMCARD_MACROREGIAO = 'simcard_macroregiao',
}

export enum AlarmGraphAppNameOptions {
  APPNAME_AVERAGE_TIME = 'transacao_tempo_medio',
  APPNAME_TRANSACTIONS_BY_STATUS = 'transacao_por_status',
  APPNAME_TRANSACTION_HISTORY = 'transacao_historico',
  APPNAME_TRANSACTION_STATUS = 'transacao_de_status',
  APPNAME_TRANSACTIONS_BY_TYPE = 'transacao_tipo_status',
}
